import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/taccuino/nuovo_dolore_bianco.png'
import _imports_1 from '@/assets/images/taccuino/nuovo_dolore_verde.png'
import _imports_2 from '@/assets/images/taccuino/dolore_blu.png'
import _imports_3 from '@/assets/images/taccuino/dolore_viola.png'
import _imports_4 from '@/assets/images/taccuino/dolore_porpora.png'
import _imports_5 from '@/assets/images/taccuino/dolore_rosso.png'


const _withScopeId = n => (_pushScopeId("data-v-96d1cf00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "canvas" }
const _hoisted_3 = { class: "penelli" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-eraser icon-2x" }, null, -1))
const _hoisted_12 = { class: "notes" }
const _hoisted_13 = { class: "notes-descrizione" }
const _hoisted_14 = { class: "notes-data" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-eraser icon-2x" }, null, -1))
const _hoisted_16 = { class: "omino" }

import { ref, Ref, onMounted, onBeforeMount, onBeforeUpdate } from "vue";
import { patientStore } from "@/store/patient";
import { authStore } from "@/store/authorize";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { Taccuino } from "@/../../EshJSLib/models/patient";
import { getTaccuinoImage } from "@/../../EshJSLib/services/taccuinoService";
import { Data } from "@/../../EshJSLib/models/patient";
import { Input } from "flowbite-vue";
interface OminoProperties {
  frontCursorPosition: { previousX: number; previousY: number };
  backCursorPosition: { previousX: number; previousY: number };
  backgroundColor: string;
  brushColor: string;
  lineWidth: number;
  canvasImageElement: HTMLImageElement;
  canvasImageElementOutline: HTMLImageElement;
  canvasImageBackElement: HTMLImageElement;
  canvasImageBackElementOutline: HTMLImageElement;
}


type Canvastype = {

  x: number,
  y: number,
  isDrawing: boolean,
  canvasElement: HTMLCanvasElement,
  canvasContext: CanvasRenderingContext2D
  style: {
    backgroundColor: string;
    brushColor: string;
    lineWidth: number;
  },
  images:
  {
    canvasImageElement: HTMLImageElement;
    canvasImageElementOutline: HTMLImageElement;
  }


}


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasTemplate',
  emits: ["canvasElement", "onSave", "onReset"],
  setup(__props, { expose: __expose, emit }) {

const canvasElement: Ref<HTMLCanvasElement | undefined> = ref();
const canvasBackElement: Ref<HTMLCanvasElement | undefined> = ref();
const ctx: Ref<CanvasRenderingContext2D | undefined> = ref();
const ctxBack: Ref<CanvasRenderingContext2D | undefined> = ref();
const store = patientStore();
const auth = authStore();
const { patient } = storeToRefs(store);
const router = useRouter();
const route = useRoute();
const showLoading = ref(false);
const editing = ref(null);

let canvasData: Canvastype


let canvasDataBack: Canvastype


function getCurrentCanvas(e) {

  let currentCanvas = canvasData;
  if (e.currentTarget.id === 'back') {
    currentCanvas = canvasDataBack;
  }

  return currentCanvas;

}

function drawLine(data: Canvastype, x2, y2) {

  let ctx = data.canvasContext;
  ctx.beginPath();

  ctx.lineWidth = data.style.lineWidth;
  ctx.lineCap = "round";
  ctx.strokeStyle = color.value;


  ctx.lineWidth = data.style.lineWidth;
  ctx.moveTo(data.x, data.y);
  ctx.lineTo(x2, y2);
  ctx.stroke();
  ctx.closePath();
}

function beginDrawing(e) {
  let currentCanvas = getCurrentCanvas(e);
  currentCanvas.x = e.offsetX;
  currentCanvas.y = e.offsetY;
  currentCanvas.isDrawing = true;
}


function keepDrawing(e) {

  let currentCanvas = getCurrentCanvas(e);

  if (currentCanvas && currentCanvas.isDrawing === true) {
    drawLine(currentCanvas, e.offsetX, e.offsetY);
    currentCanvas.x = e.offsetX;
    currentCanvas.y = e.offsetY;

    currentCanvas.canvasContext.drawImage(
      currentCanvas.images.canvasImageElementOutline,
      0,
      0,
      canvasElement.value.width,
      canvasElement.value.height);

  }
}
function stopDrawing(e) {
  let currentCanvas = getCurrentCanvas(e);

  if (currentCanvas.isDrawing && currentCanvas.isDrawing === true) {
    drawLine(currentCanvas, e.offsetX, e.offsetY);
    currentCanvas.x = 0;
    currentCanvas.y = 0;
    currentCanvas.isDrawing = false;
  }
}



let color = ref("white");
let routeId = ref(null);

let selectedId = route.params.id;

let rowValue = patient.value.tbl_taccuinos.find(
  (taccuino) => taccuino.id_taccuino === Number(selectedId) || 0
);

const todayDate = new Date().toISOString().substr(0, 10);

if (rowValue == null) {
  rowValue = {} as Taccuino;
  rowValue.id_taccuino = 0;
  rowValue.id_paziente = patient.value.id_paziente;
  rowValue.author_id = patient.value.id_paziente;
  rowValue.taccuino_2d_drawn = 1;
  rowValue.taccuino_data = todayDate;
}





let addItems = ref([] as Object);

onMounted(async () => {
  ctx.value = canvasElement.value?.getContext("2d") || undefined;
  ctxBack.value = canvasBackElement.value?.getContext("2d") || undefined;


  canvasData = { x: 0, y: 0, isDrawing: false, canvasContext: ctx.value, images: { canvasImageElement: new Image(), canvasImageElementOutline: new Image() }, style: null, canvasElement: canvasElement.value };
  canvasDataBack = { x: 0, y: 0, isDrawing: false, canvasContext: ctxBack.value, images: { canvasImageElement: new Image(), canvasImageElementOutline: new Image() }, style: null, canvasElement: canvasBackElement.value };

  getImages(rowValue).then(() => {
    prepareCanvas();
  });




});


//TEMPLATE MODEL 2D
function prepareCanvas() {
  console.log("Canvas: .. . prepareCanvas");
  canvasData.style = { backgroundColor: "#ffffff", brushColor: "#ffffff", lineWidth: 5 }
  canvasDataBack.style = { backgroundColor: "#ffffff", brushColor: "#ffffff", lineWidth: 5 }

  if (route.params.id === 'Nuova') {


    canvasData.images.canvasImageElement.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_front.png')
    canvasDataBack.images.canvasImageElement.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_back.png')
    canvasData.images.canvasImageElementOutline.onload = () => preloadImage(canvasData, false)
    canvasDataBack.images.canvasImageElementOutline.onload = () => preloadImage(canvasDataBack, false)

  }
  canvasData.images.canvasImageElementOutline.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_front_.png');
  canvasDataBack.images.canvasImageElementOutline.src = require('@/assets/images/taccuino/' + patient.value.paziente_sesso + '_back_.png');


  if (route.params.id !== 'Nuova') {
    preloadImage(canvasData, true)
    preloadImage(canvasDataBack, true)
  }



}
function preloadImage(data: Canvastype, edit: Boolean) {

  // canvas.width = 419;
  //canvas.height = 866;

  if (edit) {
    data.canvasContext.drawImage(data.images.canvasImageElement, 0, 0, data.canvasElement.width, data.canvasElement.height);
    editing.value = true;
  } else {
    data.canvasContext.drawImage(data.images.canvasImageElementOutline, 0, 0, data.canvasElement.width, data.canvasElement.height);
    data.canvasContext.fillStyle = data.style.backgroundColor;
    data.canvasContext.fillRect(0, 0, data.canvasElement.width, data.canvasElement.height);
    data.canvasContext.drawImage(data.images.canvasImageElementOutline, 0, 0, data.canvasElement.width, data.canvasElement.height);
    editing.value = false;
  }

}
async function getImages(row: Taccuino) {
  try {
    if (rowValue.id_taccuino == 0)
      return;

    showLoading.value = true;
    await getTaccuinoImage(row.id_taccuino).then((result) => {

      showLoading.value = false

      let rowValue = patient.value.tbl_taccuinos.find(
        (taccuino) => taccuino.id_taccuino === Number(result.id_taccuino)

      );

      rowValue.taccuino_report_anteriore = result.taccuino_report_anteriore;
      rowValue.taccuino_report_posteriore = result.taccuino_report_posteriore;
      canvasData.images.canvasImageElement.src = rowValue.taccuino_report_anteriore
      canvasDataBack.images.canvasImageElement.src = rowValue.taccuino_report_posteriore

    });



  } catch (error) {
    console.error("Error fetching image:", error);
  }
}


function saveTaccuino() {

  rowValue.taccuino_report_anteriore = canvasElement.value?.toDataURL()
  rowValue.taccuino_report_posteriore = canvasBackElement.value?.toDataURL()

  emit('onSave', rowValue);

}



function color_dolore(colore) {
  color.value = colore;
  console.log("change color " + colore);
}

function erase_dolore() {
  preloadImage(canvasData, editing.value)
  preloadImage(canvasDataBack, editing.value)
}

function cancella_tutto() {

  ctx.value.fillStyle = canvasData.style.backgroundColor;
  ctx.value.fillRect(0, 0, canvasElement.value.width, canvasElement.value.height);
  ctxBack.value.fillStyle = canvasData.style.backgroundColor;
  ctxBack.value.fillRect(0, 0, canvasElement.value.width, canvasElement.value.height);


  ctx.value.drawImage(
    canvasData.images.canvasImageElement,
    0,
    0,
    canvasElement.value.width,
    canvasElement.value.height
  );


  ctxBack.value.drawImage(
    canvasDataBack.images.canvasImageElement,
    0,
    0,
    canvasElement.value.width,
    canvasElement.value.height);
}

function selectColor(color) {
  color.value = color;
}

__expose({ erase_dolore });


return (_ctx: any,_cache: any) => {
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (color_dolore('#ffffff')))
        }, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("Nessun dolore")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (color_dolore('#00ff00')))
        }, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.$t('Dolore lieve')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (color_dolore('#2323d2')))
        }, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore moderato')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (color_dolore('#8a2070')))
        }, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.$t('Dolore intenso')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          style: {"text-align":"center"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (color_dolore('#7a0026')))
        }, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore forte')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
          style: {"text-align":"center"},
          onClick: _cache[5] || (_cache[5] = ($event: any) => (color_dolore('#ff0000')))
        }, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Dolore molto forte')), 1)
        ]),
        _hoisted_10,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (erase_dolore()))
          }, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Cancella i cambiamenti')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(rowValue).taccuino_descrizione) = $event)),
            placeholder: 'Inserisci la descrizione'
          }, null, 512), [
            [_vModelText, _unref(rowValue).taccuino_descrizione]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(rowValue).taccuino_data) = $event))
          }, null, 512), [
            [_vModelText, _unref(rowValue).taccuino_data]
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
              onClick: saveTaccuino
            }, _toDisplayString(_ctx.$t('Salva')), 1),
            _createElementVNode("button", {
              class: "mt-4 text-white bg-red-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-red-800",
              onClick: _cache[9] || (_cache[9] = ($event: any) => {_unref(router).push(`/Registro/Taccuino`);})
            }, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Annulla')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          _createElementVNode("canvas", {
            ref_key: "canvasElement",
            ref: canvasElement,
            width: "419",
            height: "866",
            id: "front",
            onMousedown: beginDrawing,
            onMousemove: keepDrawing,
            onMouseup: stopDrawing,
            onTouchstart: beginDrawing,
            onTouchmove: keepDrawing,
            onTouchend: stopDrawing
          }, null, 544)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("canvas", {
            ref_key: "canvasBackElement",
            ref: canvasBackElement,
            width: "419",
            height: "866",
            id: "back",
            onMousedown: beginDrawing,
            onMousemove: keepDrawing,
            onMouseup: stopDrawing,
            onTouchstart: beginDrawing,
            onTouchmove: keepDrawing,
            onTouchend: stopDrawing
          }, null, 544)
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, { ref: "alertModal" }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})